export const CACHE_KEY = 'gd-laboratory';



// WEBPACK FOOTER //
// ./src/constants/index.js